export default "__VITE_ASSET__S6YWOS91__"